import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AvailableQueryParameters } from '@quorum/models/xs-query';
import { ApiService } from '@quorum/api';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { NoteQueryParameters } from '@quorum/models/xs-query';
import { Associate, Employee } from '@quorum/models/xs-resource';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import * as moment from 'moment';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { CustomerNotesDialogComponent } from '../customer-notes-dialog/customer-notes-dialog.component';
import { MediaStateService } from '@quorum/sha-media';
import { MediaGalleryDialogComponent } from 'libs/sha-components-ng-ui/src/lib/media-gallery-dialog/media-gallery-dialog.component';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-vehicle-card',
  templateUrl: './vehicle-card.component.html',
  styleUrls: ['./vehicle-card.component.scss'],
})
export class VehicleCardComponent implements OnInit, OnChanges {
  @Input() vehicleId: number;
  @Input() vin: string;
  @Output() edit: EventEmitter<boolean> = new EventEmitter();
  @Input() associate: Associate;
  vehicleImage: SafeResourceUrl;
  cardData$: Observable<any>;
  today: Date = new Date();
  basicWarrantyStatus: string;
  mileageLabel: string = '';
  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private authenticationStateService: AuthenticationStateService,
    private systemControlStateService: SystemControlStateService,
    public dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private mediaStateService: MediaStateService,
    public serviceLaneFacade: ServiceLaneFacade
  ) {}

  ngOnInit() {
    this.authenticationStateService
      .selectAuthenticatedEmployee()
      .pipe(
        filter((employee) => employee != null),
        take(1)
      )
      .subscribe((employee: Employee) => {
        this.systemControlStateService
          .getSystemControlValue('CL_DEALER_COUNTRY_ID', employee.rooftopId)
          .pipe(take(1))
          .subscribe((sct) => {
            this.mileageLabel = sct.value == 'USA' ? 'mi.' : 'km';
          });
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.vehicleId && changes.vehicleId.currentValue != null) {
      this.getVehicleData(changes.vehicleId.currentValue);
    }
    if (changes.vin && changes.vin.currentValue != null) {
      this.apiService
        .get(`/v/1/reporting/vehicles/image/${changes.vin.currentValue}?size=large`)
        .pipe(take(1))
        .subscribe((photo) => {
          if (photo.file_contents) {
            this.vehicleImage = this.sanitizer.bypassSecurityTrustResourceUrl(
              `data:image/jpg;base64,${photo.file_contents}`
            );
          } else {
            this.vehicleImage = null;
          }
        });
    }
  }
  getVehicleData(vehicleId: number) {
    this.serviceLaneFacade.customerAssociate$
      .pipe(
        filter((associate) => associate != null),
        take(1)
      )
      .subscribe((associate) => {
        this.serviceLaneFacade.getAllNotes(associate.id, null, vehicleId.toString());
      });

    let params: AvailableQueryParameters = new AvailableQueryParameters({ vehicleId: vehicleId.toString() });

    this.cardData$ = combineLatest(
      this.apiService.get(`v/1/reporting/crm/available`, { params: params }),
      this.apiService.get(`v/1/reporting/vehicles/workflow/warranties/${vehicleId}`),
      this.apiService.get(`v/1/vehicles/vehicles/${vehicleId}`, { params: { embed: 'associate' } })
    ).pipe(
      map(([vehicleReport, warrantyInfo, vehicle]) => {
        return {
          vehicleReport: vehicleReport.length == 1 ? vehicleReport[0] : null,
          warrantyInfo: warrantyInfo,
          vehicle: vehicle,
        };
      }),
      tap((data) => {
        if (data.warrantyInfo.regularWarranty) {
          if (data.vehicle.deliveryDate) {
            let date = moment(data.vehicle.deliveryDate).add(data.warrantyInfo.regularWarranty.warrantyTerm, 'months');

            if (
              date.isAfter(new Date()) &&
              data.warrantyInfo.regularWarranty.warrantyMileage > data.vehicle.currentMileage
            ) {
              this.basicWarrantyStatus = 'Effective';
            } else {
              this.basicWarrantyStatus = 'Expired';
            }
          } else {
            this.basicWarrantyStatus = 'Unknown';
          }
        }
      })
    );
  }

  editMode() {
    console.log('edit baybay');
    this.edit.emit(true);
  }

  openNotesDialog(associateId: string, vehicleId: string) {
    const dialogRef = this.dialog.open(CustomerNotesDialogComponent, {
      width: '500px',
      data: { associateId: associateId, vehicleId: vehicleId },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  openMediaDialog() {
    this.mediaStateService.loadMediaForVehicle(this.vehicleId);
    const dialogData: any = {
      media$: this.mediaStateService.getVehicleMedia(),
    };
    const dialogRef = this.dialog.open(MediaGalleryDialogComponent, {
      width: '800px',
      height: '600px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {});
  }

  // visitDashboard(associate: Associate, vehicleId: number) {
  //   this.router.navigate([`oem-dashboard`], {
  //     relativeTo: this.activatedRoute.parent,
  //     queryParams: { oemrtId: '1', vehicleVin: 'KM8J3CAL6MU364987', odometerIn: '10', employeeId: associate.id, oem: 'HYU', vehicleId: vehicleId },
  //   });
  // }

  // visitMenu() {
  //   //HYU
  //   //workOrderId: '295602'
  //   //appointmentId: '316206'

  //   //GM
  //   //workOrderId: '73883'
  //   //appointmentId: '79948'

  //   this.router.navigate([`oem-menu`], {
  //     relativeTo: this.activatedRoute.parent,
  //     queryParams: {
  //       odometer: '120001',
  //       oem: 'GM',
  //       transactionId: '73883',
  //       transactionType: 'workOrder',
  //       //vehicleId: '98823',
  //       vehicleId: '38674',
  //     },
  //   });
  // }
}
